import classes from 'components/common/Tables/Cells/relationTypeCell.module.scss';
import React from 'react';

export const RelationTypeCell = ({ value }: { value: string }) => {
    return <div className={classes.relationType}>{value}</div>;
};
